import React from "react";
import { CheckCircle2, Clock, Sparkles, MapPin } from "lucide-react";

const POINTS = [
  {
    icon: Clock,
    title: "14 ani de experiență",
    text: "Aproape două decenii de renovări în care am rafinat fiecare detaliu.",
  },
  {
    icon: CheckCircle2,
    title: "Peste 400 de lucrări finalizate",
    text: "Case, apartamente, băi complete și amenajări exterioare — livrate la termen.",
  },
  {
    icon: Sparkles,
    title: "Seriozitate & calitate",
    text: "Contract clar, materiale verificate, execuție curată. Fără costuri ascunse.",
  },
  {
    icon: MapPin,
    title: "Constanța & împrejurimi",
    text: "Ne deplasăm în tot județul: Mamaia, Năvodari, Ovidiu, Techirghiol, Eforie și zonele adiacente.",
  },
];

export default function About() {
  return (
    <section
      id="despre"
      data-testid="about-section"
      className="relative py-24 md:py-32"
    >
      <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 reveal">
          <div className="eyebrow mb-5">
            <span>Despre noi</span>
          </div>
          <h2 className="font-display text-[var(--text-primary)] text-4xl md:text-5xl leading-[1.08] font-medium">
            O echipă locală care{" "}
            <span className="text-brand-blue italic">construiește încredere</span>,
            an de an.
          </h2>
          <p className="mt-6 text-[var(--text-secondary)] text-base md:text-lg leading-relaxed">
            <span className="text-[var(--text-primary)] font-semibold">SC Aurel Calin Premium SRL</span>{" "}
            este o firmă din Constanța specializată în renovări și construcții
            complete pentru case și apartamente. În 14 ani am dus la bun sfârșit
            peste 400 de lucrări — de la modernizări punctuale, până la
            amenajări la cheie.
          </p>
          <p className="mt-4 text-[var(--text-muted)] leading-relaxed">
            Lucrăm cu o echipă proprie, respectăm termenele stabilite prin
            contract și punem accent pe calitatea finisajelor. Fiecare proiect
            este tratat ca și cum ar fi propria noastră casă.
          </p>

          <div className="mt-9 grid grid-cols-3 gap-4 md:gap-6 max-w-md">
            <Stat value="14" label="ani experiență" />
            <Stat value="400+" label="lucrări finalizate" />
            <Stat value="100%" label="clienți mulțumiți" />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 md:gap-5">
          {POINTS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`about-point-${idx}`}
                className="reveal p-6 md:p-7 rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-card)] hover:border-[rgba(30,95,217,0.35)] transition-colors"
                style={{ transitionDelay: `${idx * 60}ms` }}
              >
                <div className="h-10 w-10 rounded-lg bg-[rgba(245,166,35,0.10)] border border-[rgba(245,166,35,0.35)] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={2.2} />
                </div>
                <h3 className="mt-5 font-display text-lg md:text-xl text-[var(--text-primary)] font-medium">
                  {p.title}
                </h3>
                <p className="mt-2 text-[var(--text-secondary)] text-sm md:text-[15px] leading-relaxed">
                  {p.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display text-3xl md:text-4xl font-medium text-[var(--text-primary)] leading-none">
        {value}
      </div>
      <div className="mt-2 text-[11px] uppercase tracking-[0.18em] text-[var(--text-muted)]">
        {label}
      </div>
    </div>
  );
}
